import { cn } from '@/lib/utils'
import { LayoutPanelLeft, Inbox } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ViewSwitcher } from './view-switcher'

export function BottomNav({
  activeTab,
  handleViewSelect,
  handleToggleSidebar,
  handleInboxClick,
  className,
}) {
  return (
    <div
      className={cn(
        'sticky bottom-0 left-0 right-0 z-40 w-full',
        'flex items-center justify-between px-6 py-3',
        'bg-background/80 backdrop-blur-md border-t border-border/10',
        className,
      )}
    >
      <div className="flex-1 flex justify-center">
        <ViewSwitcher activeTab={activeTab} handleViewSelect={handleViewSelect} />
      </div>

      <div
        className="flex flex-col items-center gap-0.5 cursor-pointer group hover:opacity-80 transition-opacity"
        onClick={handleInboxClick}
      >
        <Button variant="ghost" size="icon" className="rounded-full h-9 w-9 shrink-0">
          <Inbox className="h-5 w-5" />
        </Button>
        <span className="text-[10px] font-medium text-muted-foreground transition-colors group-hover:text-foreground">
          Inbox
        </span>
      </div>
    </div>
  )
}
